// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__gDrtC","navWrapper":"styles_navWrapper__WSL8+"};